import React, { useEffect } from 'react';

const VARIANTS = {
  success: {
    bg: 'bg-emerald-600',
    icon: '✓',
  },
  error: {
    bg: 'bg-red-600',
    icon: '✕',
  },
  warning: {
    bg: 'bg-amber-500',
    icon: '⚠',
  },
  info: {
    bg: 'bg-blue-600',
    icon: 'ℹ',
  },
};

/**
 * Lightweight toast notification.
 *
 * @param {{ message: string, variant?: 'success'|'error'|'warning'|'info', visible: boolean, onDismiss: () => void, duration?: number }} props
 */
const Toast = ({ message, variant = 'success', visible, onDismiss, duration = 2500 }) => {
  useEffect(() => {
    if (!visible) return;
    const timer = setTimeout(onDismiss, duration);
    return () => clearTimeout(timer);
  }, [visible, onDismiss, duration]);

  if (!visible) return null;

  const { bg, icon } = VARIANTS[variant] || VARIANTS.info;

  return (
    <div
      className={`fixed top-20 left-1/2 -translate-x-1/2 ${bg} text-white py-2.5 px-5 rounded-lg text-sm font-medium shadow-lg z-[1000] animate-fadeInOut flex items-center gap-2`}
    >
      <span>{icon}</span>
      <span>{message}</span>
    </div>
  );
};

export default Toast;
